"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferAction = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _culture = require("@ori/culture");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _FormattedMessage = require("../FormattedMessage");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexFlow: 'column',
  padding: theme.spacing(5, 3)
}));
const TopDivider = (0, _mui.styled)(_mui.Divider)(({
  theme
}) => ({
  borderTop: `2px solid ${theme.palette.grey[100]}`,
  borderWidth: '2px 0 0',
  marginBottom: theme.spacing(2),
  width: '100%'
}));
const Totals = (0, _mui.styled)('div')(() => ({
  alignSelf: 'end',
  textAlign: 'right'
}));
const OriginalPrice = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  ...(0, _shared.originalPriceStyles)(theme),
  display: 'block'
}));
const OfferAction = ({
  isAdding,
  isDisabled,
  onAddOffer,
  totalPrice,
  totalPurchasePrice: rawTotalPurchasePrice
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const totalPurchasePrice = rawTotalPurchasePrice ?? totalPrice;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    "data-testid": getTestId('action-wrapper'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(TopDivider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Totals, {
      "data-testid": getTestId('price-totals'),
      children: [totalPrice !== totalPurchasePrice && /*#__PURE__*/(0, _jsxRuntime.jsx)(OriginalPrice, {
        "data-testid": getTestId('original-price'),
        variant: "caption",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
          children: totalPurchasePrice
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
        variant: "button",
        component: "span",
        fontWeight: "normal",
        marginRight: 1,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "total"
        }), ":"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        "data-testid": getTestId('price'),
        variant: "body1",
        component: "span",
        fontWeight: "bold",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_culture.FormatCurrency, {
          children: totalPrice
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      maxWidth: "500px",
      color: "primary",
      "data-testid": getTestId('add-button'),
      disabled: isAdding || Boolean(isDisabled),
      loading: isAdding,
      variant: "contained",
      sx: {
        marginTop: 2
      },
      onClick: onAddOffer,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: "add"
      })
    })]
  });
};
exports.OfferAction = OfferAction;